export default __webpack_public_path__ + "static/media/buscar.9ad29f6d.svg";